export default __webpack_public_path__ + "static/banner-common-mistakes-when-buying-a-car-8fa0f4633e6f1844f899e14c8a1bafc8.jpg";